import styled from "styled-components";
import { motion } from "framer-motion";

/* ── Trigger ── */
export const Wrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const TriggerBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  transition: color 0.3s ease;
  color: ${({ theme }) => theme.textSecondary};
  &:hover {
    color: ${({ theme }) => theme.accent};
  }
`;

/* ── Desktop dropdown panel ── */
export const Panel = styled(motion.div)`
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  background: ${({ theme }) =>
    theme.light ? "rgba(255, 255, 255, 0.95)" : "rgba(10, 10, 10, 0.95)"};
  border: 1px solid ${({ theme }) => theme.cardBorder};
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  min-width: 220px;
  padding: 8px 0;
  z-index: 100;
`;

export const SectionLabel = styled.div`
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.textSecondary};
  padding: 10px 16px 6px;
`;

export const Divider = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.cardBorder};
  margin: 4px 0;
`;

export const OptionRow = styled.button`
  width: 100%;
  background: none;
  border: none;
  cursor: pointer;
  padding: 9px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: ${({ theme }) => theme.font};
  font-size: 0.82rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  color: ${({ $active, theme }) =>
    $active ? theme.accent : theme.textSecondary};
  transition:
    color 0.2s,
    background 0.2s;

  &:hover {
    color: ${({ theme }) => theme.accent};
    background: ${({ theme }) =>
      theme.light ? "rgba(0, 0, 0, 0.03)" : "rgba(255, 255, 255, 0.03)"};
  }

  &:disabled {
    opacity: 0.35;
    cursor: default;
    &:hover {
      color: ${({ theme }) => theme.textSecondary};
      background: none;
    }
  }
`;

export const OptionLabel = styled.span`
  flex: 1;
  text-align: left;
`;

export const CheckIcon = styled.span`
  color: ${({ theme }) => theme.accent};
  display: flex;
  align-items: center;
`;

export const ToggleRow = styled.button`
  width: 100%;
  background: none;
  border: none;
  cursor: pointer;
  padding: 9px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: ${({ theme }) => theme.font};
  font-size: 0.82rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.textSecondary};
  transition:
    color 0.2s,
    background 0.2s;

  &:hover {
    color: ${({ theme }) => theme.accent};
    background: ${({ theme }) =>
      theme.light ? "rgba(0, 0, 0, 0.03)" : "rgba(255, 255, 255, 0.03)"};
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const ToggleLabel = styled.span`
  flex: 1;
  text-align: left;
`;

export const ToggleIndicator = styled.span`
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: ${({ $on, theme }) => ($on ? theme.accent : theme.textSecondary)};
`;

/* ── Mobile layout ── */
export const MobileWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  padding-top: 16px;
`;

export const MobileSectionLabel = styled.div`
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.textSecondary};
  padding: 12px 0 6px;
`;

export const MobileOptionRow = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px 0;
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: ${({ theme }) => theme.font};
  font-size: 0.85rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  color: ${({ $active, theme }) =>
    $active ? theme.accent : theme.textSecondary};
  transition: color 0.2s;

  &:disabled {
    opacity: 0.35;
    cursor: default;
  }
`;

export const MobileOptionGrid = styled.div`
  display: flex;
  gap: 12px;
`;

export const MobileToggleRow = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px 0;
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: ${({ theme }) => theme.font};
  font-size: 0.85rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.textSecondary};
  transition: color 0.2s;

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const MobileHint = styled.p`
  font-size: 0.72rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.textSecondary};
  opacity: 0.75;
  margin: 6px 0 0;
  font-style: italic;
`;
